import { Button, Cell, Grid, HFlow, Icon, Tooltip, VFlow } from 'bold-ui'
import { DateField, Form, FormRenderProps, MunicipioSelectField, SubmitButton, TextField } from 'components/form'
import { useServerTime } from 'hooks/useServerTime'
import React from 'react'
import { metaPath } from 'util/metaPath'
import { createValidator, ErrorObject, maxLength } from 'util/validation'
import { InternalGovBrButton } from 'view/login/InternalGovBrButton'

import CidadaoPesquisarFormModel from '../types/model-pesquisarCidadao'
import { useNeedLoginGovBrToCadsus } from '../useNeedLoginGovBrToCadsus'

const path = metaPath<CidadaoPesquisarFormModel>()

export const validate = createValidator<CidadaoPesquisarFormModel>(
  {
    nomeCpfCns: maxLength[100],
    nomeMae: maxLength[100],
  },
  (values) => {
    const errors: ErrorObject<CidadaoPesquisarFormModel> = {}

    if (values && values.nomeCpfCns && Number(values.nomeCpfCns)) {
      if (values.nomeCpfCns.length !== 11 && values.nomeCpfCns.length !== 15) {
        return { nomeCpfCns: 'Informe um CPF ou CNS válido para realizar a busca' }
      }
    }

    return errors
  }
)

interface CidadaoPesquisarProps {
  handleSubmitPesquisa(form: CidadaoPesquisarFormModel): void
  initialValue?: CidadaoPesquisarFormModel
}

export function CidadaoPesquisarForm(props: CidadaoPesquisarProps) {
  const { getServerTimeNow } = useServerTime()
  const now = getServerTimeNow()

  const { needLoginGovBr } = useNeedLoginGovBrToCadsus()

  const renderForm = (formProps: FormRenderProps<CidadaoPesquisarFormModel>) => {
    const clearFields = () => {
      formProps.form.change(path.nomeCpfCns.absolutePath(), null)
      formProps.form.change(path.dataNascimento.absolutePath(), null)
      formProps.form.change(path.nomeMae.absolutePath(), null)
      formProps.form.change(path.municipio.absolutePath(), null)
    }

    return (
      <form onSubmit={formProps.handleSubmit} noValidate>
        <VFlow>
          <Grid>
            <Cell xs={12}>
              <TextField
                uppercase
                name={path.nomeCpfCns}
                label='Nome/CNS/CPF do cidadão'
                maxLength={200}
                style={{ fontSize: '1.5rem' }}
              />
            </Cell>
            <Cell sm={2} xs={12}>
              <DateField name={path.dataNascimento} maxDate={now} label='Data de nascimento' />
            </Cell>
            <Cell sm={5} xs={12}>
              <TextField uppercase name={path.nomeMae} label='Nome da mãe' />
            </Cell>
            <Cell sm={5} xs={12}>
              <MunicipioSelectField name={path.municipio} label='Município de nascimento' />
            </Cell>
          </Grid>
          <HFlow justifyContent='flex-end' style={{ paddingBottom: '15px' }}>
            {needLoginGovBr && (
              <Tooltip text='Para acessar os serviços do CADSUS, é necessário estar logado no gov.br.'>
                <HFlow justifyContent='center'>
                  <InternalGovBrButton href='/oauth2/authorization/govbr' />
                </HFlow>
              </Tooltip>
            )}
            <Button kind='normal' skin='outline' size='medium' onClick={clearFields}>
              Limpar filtros
            </Button>
            <SubmitButton
              kind='primary'
              skin='default'
              size='medium'
              handleSubmit={formProps.handleSubmit}
              data-cy='BuscarCidadaoButton'
            >
              <Icon icon='zoomOutline' style={{ marginRight: '0.5rem' }} />
              Buscar cidadão
            </SubmitButton>
          </HFlow>
        </VFlow>
        <input type='submit' hidden />
      </form>
    )
  }

  return (
    <Form<CidadaoPesquisarFormModel>
      render={renderForm}
      validate={validate}
      initialValues={props.initialValue}
      onSubmit={props.handleSubmitPesquisa}
    />
  )
}
